import { Direction, Directionality } from "@angular/cdk/bidi";
import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Device } from "@ionic-native/device/ngx";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService, DeviceType } from "ngx-device-detector";
import { Observable, of, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { AlertsService } from "./AlertsService";
import { ErrorValidatorService } from "./common/directives/error-handler/error-validator.service";
import {
  EAccountServiceCode,
  EDepositServiceCode,
} from "./common/models/service-code.model";
import { MobileService } from "./mobile.services";
import { IDeviceInfo } from "./models/app-common.model";
import { SpinnerService } from "./services/spinner/spinner.service";
import { UserService } from "./user.service";
import { ToastrService } from "ngx-toastr";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";

declare var jscd: any;
declare var window: any;
declare let $: any;
declare const JSEncrypt: any;

@Injectable({
  providedIn: "root",
})
export class CommonService {

  backNav = new EventEmitter();
  public searchRequired: boolean = false;
  public serviceDescription: string = "";
  public isbackBtn:boolean= false;
  language: string = "En";
  desktopVersion: boolean;
  mobileVersion: boolean;
  tabletVersion: boolean;
  encodedDeviceDetails: string;
  deviceInfo: IDeviceInfo;

  customerCode: string = "";

  rtlDirection$ = new Subject<boolean>();
  isRtl: boolean = false;

  baseCurrency: string = "USD";
  baseCurrencySymbol: string = "$";
  showLangSwitcher: boolean;
  SALT =
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA32rpoAO6Obi/4kydkyqHTd5Co5vfXatm/hTBlUVy66hlHpINiyHWcQUlRpPka0YLB4oEReccCzfJT37+CJ6riJ48wefEslNf2wNFuuBMbykSk4dp6XF+RvbL2Lo6aGhr+ZvSKRDx63OgCp2tarFbbo6WEXQx1HTGTl0A3i8mX02VlHpZMK9m3xSg5XYnEpRUMuGUHJQuhafrRAybPkoAQBrH88Y27os2F+M1cp8OYWUeEo+SRlkVSaWPgauZ6IXwmX5lL6J2dQHQZowHqy6IiYk0bCXsHHCcYBLHeW25wlCqKvstUN/Fud1B/IYBp845rh8bGOZEz4oXjpCm1S09oQIDAQAB";

  isMpinRegistered: boolean = false;
  isDeviceAuthRegistered: boolean = false;
  searchMenuList = [];

  manageSecurityItem: any;
  PurchaseOrderItem: any;
  SellOrderItem: any;

  mutualAvailable: boolean = false;
  serviceUnAvailable: boolean;

  private _applicationMode:string;
  _rmResultScreenOn: boolean=false;
  rmAppRejected: boolean = false;
  screenWidth: any;
  screenHeight: any;

  constructor(
    public translate: TranslateService,
    private _router: Router,
    private _deviceDetector: DeviceDetectorService,
    public _alertsService: AlertsService,
    private dir: Directionality,
    private _spinnerService: SpinnerService,
    private _userService: UserService,
    private _device: Device,
    private _mobileService: MobileService,
    private _titleService: Title,
    private _httpClient: HttpClient,
    private _errorMessage: ErrorValidatorService,
    private toastrService: ToastrService,
    private socialSharing: SocialSharing,
  ) {
    this.language = localStorage.getItem("lang") || "En";
    let direction: Direction = this.language == "ar" ? "rtl" : "ltr";
    this.dir.change.emit(direction);

    this.manageSecurityItem = {
      id: "manage-security-settings",
      icon: "manage-security",
      name: "CONTEXTULAMENU.manageSecuritySettings",
      title: "CONTEXTULAMENU.manageSecuritySettingsTitle",
      path: ["shell", "settings", "manage-security-settings"],
      desktopPath: ["home", "settings", "manage-security-settings"],
    };

    this.PurchaseOrderItem = {
      id: "M001",
      icon: "purchase-order",
      name: "CONTEXTULAMENU.purchaseOrder",
      title: "CONTEXTULAMENU.purchaseOrderTitle",
      path: ["shell", "transactions", "mutual-funds", "purchase-order"],
      desktopPath: ["home", "transactions", "mutual-funds", "purchase-order"],
    };
    this.SellOrderItem = {
      id: "M002",
      icon: "sell-order",
      name: "CONTEXTULAMENU.sellOrder",
      title: "CONTEXTULAMENU.sellOrderTitle",
      path: ["shell", "transactions", "mutual-funds", "sell-order"],
      desktopPath: ["home", "transactions", "mutual-funds", "sell-order"],
    };
    this.searchMenuList = [
      // ...this._accountsService.contextualMenuList,
      // ...this._loanService.contextualMenuList,
      // ...this._depositService.contextualMenuList,
      // ...this._creditCardService.contextualMenuList,
      {
        id: "A001",
        icon: "request-cheque-book",
        name: "CONTEXTULAMENU.requestChequeBook",
        title: "CONTEXTULAMENU.requestChequeBookTitle",
        path: ["shell", "accounts", "request-cheque-book"],
        desktopPath: [ "process-shell", "casa-accounts", "cheque-book-request"],
        serviceCode: EAccountServiceCode.REQUEST_CHECK_BOOK,
        backNav : ["home", "transactions"],
      },
      {
        id: "A008",
        icon: "open-new-casa-account",
        name: "CONTEXTULAMENU.openNewCurrentAccount",
        title: "CONTEXTULAMENU.openNewCurrentAccountTitle",
        path: ["shell", "accounts", "open-new-current-account"],
        desktopPath: ["process-shell", "casa-accounts", "open-new-ca"],
        serviceCode: EAccountServiceCode.OPEN_NEW_CURRENT_ACCOUNT,
         backNav : ["home", "transactions"],
      },
      {
        id: "A009",
        icon: "open-new-casa-account",
        name: "CONTEXTULAMENU.openNewSavingsAccount",
        title: "CONTEXTULAMENU.openNewSavingsAccountTitle",
        path: ["shell", "accounts", "open-new-savings-account"],
        desktopPath: ["process-shell", "casa-accounts", "open-new-sa"],
        serviceCode: EAccountServiceCode.OPEN_NEW_SAVINGS_ACCOUNT,
        backNav : ["home", "transactions"],
      },
      {
        id: "A007",
        icon: "inquire-cheque-status",
        name: "CONTEXTULAMENU.inquireChequeStatus",
        title: "CONTEXTULAMENU.inquireChequeStatusTitle",
        path: ["shell", "accounts", "cheque-status-inquiry"],
        desktopPath: ["home", "transactions", "cheque-status-inquiry"],
        serviceCode: EAccountServiceCode.INQUIRE_CHEQUE_STATUS,
        backNav : ["home", "transactions"],
      },
      {
        id: "A002",
        icon: "request-demand-draft",
        name: "CONTEXTULAMENU.requestDemandDraft",
        title: "CONTEXTULAMENU.requestDemandDraftTitle",
        path: ["shell", "accounts", "request-dd"],
        desktopPath: [ "process-shell", "casa-accounts", "dd-request"],
        serviceCode: EAccountServiceCode.REQUEST_DD,
        backNav : ["home", "transactions"],
      },
      {
        id: "D001",
        icon: "deposit-open-new-deposit",
        name: "CONTEXTULAMENU.openDeposit",
        title: "OPENNEWDEPOSIT.title",
        path: ["shell", "deposits", "open-new-deposit"],
        desktopPath: ["home", "transactions", "deposits", "open-new-deposit"],
        serviceCode: EDepositServiceCode.OPEN_NEW_DEPOSIT,
        backNav : ["home", "transactions"],
      },
      {
        id: "AB001",
        icon: "add-payee",
        name: "CONTEXTULAMENU.addBeneficiary",
        title: "CONTEXTULAMENU.addBeneficiaryTitle",
        path: ["home", "transfers", "new-bene"],
        desktopPath: ["home", "transfers", "new-bene"],
        backNav : ["home", "transactions"],
        // serviceCode: EDepositServiceCode.OPEN_NEW_DEPOSIT
      },
      {
        id: "MB001",
        icon: "manage-payee",
        name: "CONTEXTULAMENU.managebene",
        title: "CONTEXTULAMENU.managebeneTitle",
        path: ["home", "transfers", "bene-list"],
        desktopPath: ["home", "transfers", "bene-list"],
        // serviceCode: EDepositServiceCode.OPEN_NEW_DEPOSIT
      },
      {
        id: "change-password",
        icon: "change-password",
        name: "CONTEXTULAMENU.changePassword",
        title: "CONTEXTULAMENU.changePasswordTitle",
        path: ["shell", "settings", "change-password"],
        desktopPath: ["home", "settings", "change-password"],
      },
      {
        id: "manage-alerts",
        icon: "manage-alerts",
        name: "CONTEXTULAMENU.manageAlerts",
        title: "CONTEXTULAMENU.manageAlertsTitle",
        path: ["shell", "settings", "manage-alerts"],
        desktopPath: ["home", "settings", "manage-alerts"],
      },
      {
        id: "manage-security-settings",
        icon: "manage-security",
        name: "CONTEXTULAMENU.manageSecuritySettings",
        title: "CONTEXTULAMENU.manageSecuritySettingsTitle",
        path: ["shell", "settings", "manage-security-settings"],
        desktopPath: ["home", "settings", "manage-security-settings"],
      },
      {
        id: "manage-authenticated-devices",
        icon: "manage-device",
        name: "CONTEXTULAMENU.manageAuthenticatedDevices",
        title: "CONTEXTULAMENU.manageAuthenticatedDevicesTitle",
        path: ["shell", "settings", "manage-authenticated-devices"],
        desktopPath: ["home", "settings", "manage-authenticated-devices"],
        serviceCode: "MANAGEAUTHENTICATEDDEVICES",
      },
      {
        id: "fx-rates",
        icon: "fx-rates",
        name: "CONTEXTULAMENU.fxRates",
        title: "CONTEXTULAMENU.fxRatesTitle",
        path: ["shell", "settings", "fx-rates"],
        desktopPath: ["home", "settings", "fx-rates"],
        serviceCode: "FXRATES",
      },
      {
        id: "bill-payments",
        icon: "pay-bill",
        name: "CONTEXTULAMENU.billPayments",
        title: "CONTEXTULAMENU.billPayments",
        path: ["home", "payments"],
        desktopPath: ["home", "payments"],
        serviceCode: "BILLPAYMENTS",
      },
      {
        id: "pfm",
        icon: "pfm",
        name: "CONTEXTULAMENU.pfm",
        title: "CONTEXTULAMENU.pfm",
        path: ["home", "pfm"],
        desktopPath: ["home", "pfm"],
        serviceCode: "PFM",
      },
    ];
  }

  public initializeUIClass() {
    this.desktopVersion =
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Desktop ||
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Tablet;
    this.tabletVersion =
      this._deviceDetector.getDeviceInfo().deviceType == DeviceType.Tablet;
    this.mobileVersion = !this.desktopVersion;
  }

  public isDesktop(): boolean {
    return this.desktopVersion;
  }

  public isTablet(): boolean {
    return this.tabletVersion;
  }

  public isMobile(): boolean {
    return this.mobileVersion;
  }

  public isHybrid(): boolean {
    return window["cordova"] ? true : false;
  }

  compareWithExistForm(currentFormData, previousFormData) {
    let deepCompare = (arg1, arg2) => {
      if (
        Object.prototype.toString.call(arg1) ===
        Object.prototype.toString.call(arg2)
      ) {
        if (
          Object.prototype.toString.call(arg1) === "[object Object]" ||
          Object.prototype.toString.call(arg1) === "[object Array]"
        ) {
          if (Object.keys(arg1).length !== Object.keys(arg2).length) {
            return false;
          }
          return Object.keys(arg1).every(function (key) {
            return deepCompare(arg1[key], arg2[key]);
          });
        }
        return arg1 === arg2;
      }
      return false;
    };
    return deepCompare(previousFormData, currentFormData);
  }

  public showManageSecurity() {
    console.log("Before splitting : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.isDesktop()) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.manageSecurityItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else {
      let isavailable;
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.manageSecurityItem,
          this.searchMenuList[i]
        );
        compareRes ? (isavailable = true) : (isavailable = false);
      }

      if (!isavailable) {
        this.searchMenuList.push(this.manageSecurityItem);
      }
    }

    console.log("After splitting : ", this.searchMenuList);
  }

  public showPurchaseOrder() {
    console.log("Before splitting In Purchse Order : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.mutualAvailable == false) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.PurchaseOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else if (this.mutualAvailable == true) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.PurchaseOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (!Spliceindex) this.searchMenuList.push(this.PurchaseOrderItem);
    }

    console.log("After splitting In Purchase Order : ", this.searchMenuList);
  }

  public showSellOrder() {
    console.log("Before splitting In Sell Order : ", this.searchMenuList);

    let Spliceindex;
    let compareRes;

    if (this.mutualAvailable == false) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.SellOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (Spliceindex) this.searchMenuList.splice(Spliceindex, 1);
    } else if (this.mutualAvailable == true) {
      for (let i = 0; i < this.searchMenuList.length; i++) {
        compareRes = this.compareWithExistForm(
          this.SellOrderItem,
          this.searchMenuList[i]
        );
        if (compareRes) {
          Spliceindex = i;
        }
      }
      if (!Spliceindex) this.searchMenuList.push(this.SellOrderItem);
    }

    console.log("After splitting In Sell Order: ", this.searchMenuList);
  }

  switchLanguage(language: string = "En") {
    this.translate.use(language);

    let rtl: boolean = false;
    document.getElementsByTagName("html")[0].setAttribute("lang", language);
    this.getErrorMessage(language);
    if (language === "ar") {
      environment.languageId = "ar_US";
      // this._titleService.setTitle("Smart Bank");
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
      rtl = true;
    } else {
      environment.languageId = "en_US";
      // this._titleService.setTitle("Smart Bank");
      document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
      rtl = false;
    }
    localStorage.setItem("lang", language);
    this.language = language;
    this.isRtl = rtl;
    this.rtlDirection$.next(rtl);

    let direction: Direction = rtl ? "rtl" : "ltr";
    this.dir.change.emit(direction);
  }

  getErrorMessage(lang) {
    this._httpClient
      .get("./assets/i18n/val_" + lang.toLowerCase() + ".json")
      .subscribe({
        next: (res) => {
          this._errorMessage.setErrorData(res);
        },
      });
  }

  setToken(token) {
    this._userService.setToken(token);
  }

  onLoginSuccess(data) {
    this.customerCode = data.loginauth.userId;
    sessionStorage.setItem("customerCode", this.customerCode);
    if (data && data.loginauth.authToken) {
      this.setToken(data.loginauth.authToken);
    }
  }

  loginOTPSuccess(response) {}

  getDeviceDetails(): IDeviceInfo {
    let deviceInfo: IDeviceInfo = this._deviceDetector.getDeviceInfo();
    if (this.isHybrid()) {
      deviceInfo = {
        ...deviceInfo,
        os_version: this._device.version,
        model: this._device.model,
        manufacturer: this._device.manufacturer,
        deviceId: this._mobileService.deviceID,
        app_version: this._mobileService.appVersionInfo.versionNumber,
        build_number: this._mobileService.appVersionInfo.buildNumber,
        packageName: this._mobileService.appVersionInfo.packageName,
        deviceName: window["device"].name,
      };
    } else {
      deviceInfo = {
        ...deviceInfo,
        deviceId: window["browserFingerprint"],
      };
    }
    deviceInfo.isHybrid = this.isHybrid();
    deviceInfo.device =
      deviceInfo.device == "Unknown"
        ? deviceInfo.os_version
        : deviceInfo.device;
    console.log("deviceInfo:", deviceInfo);
    // deviceInfo.deviceType = "desktop";
    // Get windows 11 start
    if (
      navigator["userAgentData"] &&
      navigator["userAgentData"].getHighEntropyValues(["platformVersion"])
    ) {
      navigator["userAgentData"]
        .getHighEntropyValues(["platformVersion"])
        .then((ua) => {
          if (navigator["userAgentData"].platform === "Windows") {
            const majorPlatformVersion = parseInt(
              ua.platformVersion.split(".")[0]
            );

            if (majorPlatformVersion >= 13 && !this.isMobile()) {
              deviceInfo.os_version = "windows-11";
              this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
              return deviceInfo;
            } else {
              this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
              return deviceInfo;
            }
          } else {
            this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
            return deviceInfo;
          }
        });
    } else {
      this.encodedDeviceDetails = btoa(JSON.stringify(deviceInfo));
      return deviceInfo;
    }
    // Get windows 11 end
  }

  showSpinner() {
    this._spinnerService.show();
  }
  hideSpinner() {
    this._spinnerService.hide();
  }
  formatAmount(number) {
    return new Intl.NumberFormat(environment.currencyFormat, {
      minimumFractionDigits: 2,
    }).format(number);
  }

  resetPageScroll(scrollTo: number) {
    if (this.isMobile()) {
      // window._scrollTop(scrollTo);
      $(document).scrollTop(0);
    } else {
      setTimeout(() => {
        $("app-root").scrollTop(scrollTo);
      }, 50);
    }
  }

  doEncrypt(message: string): string {
    try {
      let encrypt = new JSEncrypt();
      encrypt.setKey(this.SALT);
      let enc = encrypt.encrypt(message);
      return enc;
    } catch (error) {
      return message;
    }
  }
  openDocument(fileName) {
    window.open("assets/documents/" + fileName, "_system");
  }

  base64ToBlob(base64: string) {
    let sliceSize: number = 1024;
    let base64Data = base64.split(",");
    let b64Data = base64Data[1];
    let contentType = base64Data[0].match(/:(.*?);/)[1];
    const byteCharacters = atob(b64Data);

    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  base64ToFile(base64: string, filename: string) {
    var arr = base64.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = window.atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  fileToBase64(file: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
      const reader = zoneOriginalInstance || fileReader;
      reader.onloadend = () => {
        console.log("Image got to preview");
        resolve(reader.result);
      }
      reader.onerror = (error) => {
        console.error("Image preview error");
        reject(error);
      }
      reader.readAsDataURL(file);
    });
  }

  async filePathToBlob(filePath): Promise<Blob> {
    let fileBlob;
    await fetch(filePath)
      .then((res) => res.blob())
      .then((blob) => {
        console.log(blob);
        fileBlob = blob;
      });
    return fileBlob;
  }

  scaleDownImage(base64: string, width: number = 768): Promise<any> {
    let mime = base64.split(",")[0].match(/:(.*?);/)[1];
    let height;

    return new Promise((resolve, reject) => {
      const image = new Image();

      image.onload = () => {
        let canvas = document.createElement("canvas");
        let ratio = image.width / image.height;
        canvas.width = width;
        height = width / ratio;
        canvas.height = height;
        let context = canvas.getContext("2d");
        context.scale(width / image.width, height / image.height);
        context.drawImage(image, 0, 0);
        const newBase64Image = canvas.toDataURL(mime);

        resolve(newBase64Image);
      };
      image.onerror = (el, err) => {
        reject(err);
      };

      image.src = base64;
    });
  }


  getNameInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      return initial;
    }
    return
  }
  exitApplication(){
    if(this._applicationMode == 'RM') this._router.navigate(['login']);
    else window.open(window.location.origin + window.location.pathname + '#/launcher?action=application-status',"_self");
  }

  setApplicationMode(mode:string){
    this._applicationMode = mode;
  }
  getApplicationMode():string{
    return this._applicationMode || '';
  }
  isRMResultScreenOn(): boolean {
    return this._rmResultScreenOn || false;
  }

  toastrOverlayTimeout: any;
    /**
     *
     * @param data {
     *  message: '',
     *  title: '',
     *  type: 'success'
     * }
     */
    showToastr(data) {
        var msg = data.message;
        var title = data.title || "";
        var delay = data.delay || 5000;
        var toastrType = data.type || "success";

        this.toastrService[toastrType](msg, title, { timeOut: delay, closeButton: true })
            .onHidden
            .subscribe(() => this.toasterClickedHandler());

        var overlayEl = document.getElementById("toast-container").closest(".overlay-container");
        overlayEl['style'].display = "block";
        var _this = this;
        this.toastrOverlayTimeout = setTimeout(function () {
            _this.hideToasterOverlay();
        }, (delay));
    }

    toasterClickedHandler() {
        if (this.toastrOverlayTimeout) {
            clearTimeout(this.toastrOverlayTimeout);
            this.hideToasterOverlay();
        }
    }
    hideToasterOverlay() {
        var overlayEl = document.getElementById("toast-container").closest(".overlay-container");
        overlayEl['style'].display = "none";
    }
    shareInfo(content, successMsg) {
      if (this.isHybrid()) {
          this.socialSharing.share(content).then(() => {
              console.log("Info share success!");
          }).catch(() => {
              console.log("Info share failure!");
          });
      } else {
          this.copyTextToClipboard(content, successMsg, null);
      }
  }
  copyTextToClipboard(text, successMsg, successCallback) {
    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    textArea.style.padding = "0";

    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';

    textArea.style.background = 'transparent';

    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        if (successCallback) successCallback(successful);
        console.log('Copying text command was ' + msg);
        this.showToastr({
            message: successMsg
        });
    } catch (err) {
        console.log('Oops, unable to copy');
    }
    document.body.removeChild(textArea);
}

  getURL() {
    return window.location.href;
  }
    
  getURLParameter(name) {
    return (
        new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)')
        .exec( decodeURIComponent(this.getURL()))||[,""]
        )[1].replace(/\+/g, '%20')
        ||null;
  }
    
  setCookie(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
    // document.cookie = c_name + "=" + c_value + "; path=/; Secure; SameSite=Lax";
  }

  getCookie(c_name) {
    var i,x,y,ARRcookies=document.cookie.split(';');
    
    for (i=0; i < ARRcookies.length;i++) {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf('='));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name) {
          return unescape(y);
        }
    }
  }
  
  //this functions chooses between URL tag or Cookie tag
  findtag(tag) {
    var urlsource = this.getURLParameter(tag);
    var cookiesource = this.getCookie(tag) || null;
    // console.log('urlsource: ' + urlsource);
    // console.log('cookiesource: ' + cookiesource);
    
    if (urlsource != null) {
      // console.log('urlsource: ' + urlsource);
    return urlsource;
    }
    else {
      // console.log('cookiesource: ' + cookiesource);
    return cookiesource;
    }
  } 

}
